export const appConfig = {
  streetNumber: '^[^-\\s][a-zA-Z0-9_!#%@$^&*(),.\'/?":{}|<>\\s-]+',
};
